// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2F6uw","subtitle":"styles_subtitle__2nG6H"};